import React, { Component } from 'react';
// eslint-disable-next-line import/no-named-as-default
import Navigation from './Navigation';

// eslint-disable-next-line react/prefer-stateless-function
class Header extends Component {
  render() {
    return (
      <div data-test="component-header"><Navigation unsub={this.props.unsub} {...this.props} /></div>
    );
  }
}

export default Header;
